document.addEventListener('DOMContentLoaded', function () {
  /*
    const subnav = document.querySelector('.subnav')

    let isDown = false
    let startX
    let scrollLeft

    subnav.addEventListener('mousedown', (e) => {
        console.log({ e })
        isDown = true
        subnav.classList.add('active')
        startX = e.pageX - subnav.offsetLeft
        scrollLeft = subnav.scrollLeft
    })

    subnav.addEventListener('mouseleave', () => {
        isDown = false
        console.log('111')
        subnav.classList.remove('active')
    })

    subnav.addEventListener('mouseup', () => {
        isDown = false
        subnav.classList.remove('active')
    })

    subnav.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - subnav.offsetLeft
        const walk = (x - startX) * 2 // Adjust scroll speed
        subnav.scrollLeft = scrollLeft - walk
    })
        */

  // Open external links in new tab
  var NEW_WINDOW_MESSAGE_ID = 'a11y-new-window-message';
  var links = document.getElementsByTagName('a');
  var currentHost = window.location.hostname;
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    var href = link.getAttribute('href');
    if (href && href.indexOf('http') === 0) {
      var linkHost = new URL(href).hostname;
      if (linkHost !== currentHost && currentHost !== '127.0.0.1' && currentHost !== 'localhost') {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
        // Announce "opens in new window" via aria-describedby (same shared
        // message + id as abc-new-window-links.js) rather than an inline
        // visually-hidden span — a span's text still counts as the link's
        // content, and when the link also has its own aria-label (e.g. an
        // icon-only share/social link), that content stops matching the
        // accessible name, which is itself an accessibility failure.
        // aria-describedby only affects the description, never the name,
        // so it can't cause that mismatch.
        var describedBy = (link.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (describedBy.indexOf(NEW_WINDOW_MESSAGE_ID) === -1) {
          describedBy.push(NEW_WINDOW_MESSAGE_ID);
          link.setAttribute('aria-describedby', describedBy.join(' '));
        }
      }
    }
  }

  // Info Tooltip Functionality
  const tooltips = document.querySelectorAll('.info-tooltip');

  function closeTooltip(tooltip) {
    tooltip.classList.remove('active');
    const trigger = tooltip.querySelector('.info-tooltip-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus(); // Return focus to trigger for ADA compliance
    }
  }

  function openTooltip(tooltip) {
    // Close other open tooltips
    tooltips.forEach(function (otherTooltip) {
      if (otherTooltip !== tooltip) {
        closeTooltip(otherTooltip);
      }
    });

    // Open current tooltip
    tooltip.classList.add('active');
    const trigger = tooltip.querySelector('.info-tooltip-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    // Focus the close button for keyboard navigation
    const closeBtn = tooltip.querySelector('.info-tooltip-close');
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 100);
    }
  }

  tooltips.forEach(function (tooltip) {
    const trigger = tooltip.querySelector('.info-tooltip-trigger');
    const closeBtn = tooltip.querySelector('.info-tooltip-close');
    const content = tooltip.querySelector('.info-tooltip-content');

    if (trigger) {
      // Handle trigger click
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (tooltip.classList.contains('active')) {
          closeTooltip(tooltip);
        } else {
          openTooltip(tooltip);
        }
      });

      // Handle trigger keyboard events
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    }

    if (closeBtn) {
      // Handle close button click
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeTooltip(tooltip);
      });

      // Handle close button keyboard events
      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeBtn.click();
        }
      });
    } else {
    }

    // Prevent tooltip content clicks from closing the tooltip
    if (content) {
      content.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  });

  // Handle close button clicks with event delegation
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('info-tooltip-close')) {
      e.preventDefault();
      e.stopPropagation();

      // Find the parent tooltip
      const tooltip = e.target.closest('.info-tooltip');
      if (tooltip) {
        closeTooltip(tooltip);
      }
      return;
    }

    // Close tooltips when clicking outside
    tooltips.forEach(function (tooltip) {
      if (tooltip.classList.contains('active')) {
        closeTooltip(tooltip);
      }
    });
  });

  // Close tooltips on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      tooltips.forEach(function (tooltip) {
        if (tooltip.classList.contains('active')) {
          closeTooltip(tooltip);
        }
      });
    }
  });

  // Fix empty buttons in Klaviyo forms (ADA compliance)
  function fixKlaviyoButtons() {
    // Find all buttons within Klaviyo forms that don't have aria-label
    const klaviyoButtons = document.querySelectorAll(
      '.klaviyo-form button[type="button"]:not([aria-label]), .klaviyo-form button:not([type]):not([aria-label])'
    );

    klaviyoButtons.forEach(function (button) {
      // Skip if button already has aria-label or visible text content
      if (button.getAttribute('aria-label') || button.textContent.trim()) {
        return;
      }

      // Check if button contains an image
      const img = button.querySelector('img');
      if (img) {
        // Use image alt text if available
        const altText = img.getAttribute('alt');
        if (altText && altText.trim()) {
          button.setAttribute('aria-label', altText);
        } else {
          // If image has href/label attribute, use that
          const href = img.getAttribute('href');
          const label = img.getAttribute('label');
          if (label && label.trim()) {
            button.setAttribute('aria-label', label.trim());
          } else if (href) {
            button.setAttribute('aria-label', 'Go to link');
          } else {
            button.setAttribute('aria-label', 'Button');
          }
        }
      } else {
        // Button with no content - check if it's a close button
        if (button.classList.contains('klaviyo-close-form')) {
          button.setAttribute('aria-label', 'Close dialog');
        } else {
          // Generic fallback
          button.setAttribute('aria-label', 'Button');
        }
      }
    });
  }

  // Run immediately for forms already loaded
  fixKlaviyoButtons();

  // Watch for dynamically loaded Klaviyo forms
  const observer = new MutationObserver(function (mutations) {
    let shouldCheck = false;
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Check if added node or its children contain Klaviyo forms
            if (
              node.classList &&
              (node.classList.contains('klaviyo-form') || node.querySelector('.klaviyo-form'))
            ) {
              shouldCheck = true;
            }
          }
        });
      }
    });
    if (shouldCheck) {
      // Debounce to avoid excessive checks
      setTimeout(fixKlaviyoButtons, 100);
    }
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
